module.exports = __webpack_public_path__ + "static/media/lenscareActive.e7ea93c3.png";